var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ac-modal',{ref:"modalRef",attrs:{"title":'Price Tiers'}},[(_vm.widgetReady)?[_c('price-tiers',{attrs:{"read-only":true,"plan-id":_vm.planId}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }